import z from "zod";
import { LoanType } from "@cxm/client";

export const referralDataModel = z.object({
  companyName: z.string(),
  contactName: z.string(),
  contactEmail: z.string().email(),
  contactPhone: z.string().refine((v) => v.length >= 9, {
    message: "Invalid phone number.",
  }),

  loanAsk: z.number().optional(),
  loanType: z.nativeEnum(LoanType).optional(),

  referralFiles: z.string().array().optional(),
});
